import axios from "axios";

// KYC document types, a company setting (slice 2). Contract:
// snb_lightspeed_backend docs/customer-module/kyc/13-Slice-2-Full-Replacement.md
// §2 document_types and §4 Settings.
//
// Every action resolves to the whole envelope (res.data) and rejects with what
// the global interceptor rejects with: the axios response, whose `data` is the
// envelope. These are customer journey routes: a 422 carries its field errors
// under `data`, a 409 (system row, in use) its details under `data`.

export default {
    namespaced: true,

    state: {
        documentTypes: [],
        documentType: {},
    },

    getters: {
        documentTypes(state) {
            return state.documentTypes;
        },
        documentType(state) {
            return state.documentType;
        },
        // the S9 presets [{key, label}] of the last index read
        numberFormats(state) {
            return state.documentTypes?.meta?.number_formats || [];
        },
    },

    mutations: {
        SET_DOCUMENT_TYPES(state, documentTypes) {
            return (state.documentTypes = documentTypes);
        },
        SET_DOCUMENT_TYPE(state, documentType) {
            return (state.documentType = documentType);
        },
    },

    actions: {
        // GET /document-types: {data, pagination, meta: {number_formats}}.
        // Filters status_id, applies_to, category; report=1 returns every
        // match, unpaginated.
        async fetchDocumentTypes({ commit }, params) {
            return await axios
                .get("/api/v1/document-types", { params: params })
                .then((res) => {
                    commit("SET_DOCUMENT_TYPES", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        async fetchDocumentType({ commit }, documentTypeId) {
            return await axios
                .get(`/api/v1/document-types/${documentTypeId}`)
                .then((res) => {
                    commit("SET_DOCUMENT_TYPE", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        async createDocumentType({ commit }, payload) {
            return await axios
                .post("/api/v1/document-types", payload)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // PUT: keys left out keep their stored values. On a system row only
        // name, description, is_required, requires_issue_date,
        // requires_expiry_date, min_files, max_files, sort_order and status_id
        // may change.
        async updateDocumentType({ commit }, { id, payload }) {
            return await axios
                .put(`/api/v1/document-types/${id}`, payload)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // 409 when the row is a system row or in use
        async deleteDocumentType({ commit }, documentTypeId) {
            return await axios
                .delete(`/api/v1/document-types/${documentTypeId}`)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },
    },
};
